// Default organization ID — hardcoded for single-org mode.
// Replace with dynamic lookup when multi-org support is needed.
export const DEFAULT_ORG_ID = 'bca1e3a0-c4f4-4ce2-b896-42489a346c6a'
